// extracted by mini-css-extract-plugin
export default {"recsSection":"QRKpT82YoBzQHIIT7HDU","title":"oOBjvCq0lKWuHxftLNWo"};